// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"85":"camera","177":"home","214":"phone","577":"demo"}[chunkId] + "." + {"85":"8e9cef13","177":"219abd41","214":"2cf116b0","577":"cf7852ff"}[chunkId] + ".js";
};